module.exports = __webpack_public_path__ + "static/media/han-taste-ad1.43be86df.png";